export { default } from './amenitiesDetailList'
export type { TooltipAmenityChild, TooltipAmenityItem, AmenitiesDetailListProps } from './amenitiesDetailList'
